export const MOBILE_WIDTH_SCREEN = 1024;
